/**
 * Created by glenn on 3/15/2017.
 */
import React = require('react')
import makeGuid from 'webmapsjs/dist/util/makeGuid';
import * as store from './store';


interface comboProps {
    opts: Array<string[]>;
    label: string;
    // guid: string;
}

export class Combo extends React.Component<comboProps, {}> {
    // props: comboProps;
    selectBox: HTMLSelectElement;
    guid: string;

    constructor(props){
        super(props);
        this.guid = makeGuid();
    }

    change(evt){

        if (!this.selectBox){
            return;
        }

        store.store.dispatch({type: this.props.label, val: this.selectBox.value});
    }

    componentDidMount(){
        this.selectBox = document.getElementById(this.guid) as HTMLSelectElement;
        // console.log(this.selectBox);
    }

    render() {
        let rows = [];
        // {props.}

        for (let f of this.props.opts) {
            rows.push(<option key={f[1]} value={f[1]}>{f[0]}</option>);
        }

        return <div>
            <label>{this.props.label}</label>
            <select id={this.guid} onChange={(evt) => {this.change(evt)}}>
                {rows}
            </select>
        </div>
    }
}
